import React from 'react';
import type { ConsensusTableWidgetConfig } from './types';
import { definition } from './index';

interface Props {
  config: Partial<ConsensusTableWidgetConfig>;
  onChange: (config: ConsensusTableWidgetConfig) => void;
}

const ConsensusTableWidgetBuilder: React.FC<Props> = ({ config, onChange }) => {
  const params = definition.dataProvider?.params ?? [];

  return (
    <div className="space-y-4">
      <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
        <strong>{definition.meta.label}</strong>
        <p className="mt-1">{definition.meta.description}</p>
      </div>

      {params.length > 0 && (
        <div className="space-y-3">
          {params.map(param => (
            <div key={param.key}>
              <label className="block text-sm font-medium text-neutral-700 mb-1">
                {param.label}
                {param.unit && <span className="font-normal text-neutral-400 ml-1">({param.unit})</span>}
              </label>
              <input
                type={param.type || 'text'}
                placeholder={param.placeholder || String(param.defaultValue || '')}
                value={(config as any)[param.key] ?? ''}
                onChange={(e) => {
                  const val = param.type === 'number' && e.target.value
                    ? parseInt(e.target.value, 10)
                    : e.target.value || undefined;
                  onChange({ ...config, [param.key]: val } as ConsensusTableWidgetConfig);
                }}
                className="w-full border border-neutral-300 rounded-lg px-3 py-2 text-sm"
              />
            </div>
          ))}
        </div>
      )}

      <div className="border rounded-lg p-4 bg-primary-50 border-primary-200">
        <h4 className="font-medium text-primary-800 mb-2">How it works</h4>
        <ul className="text-sm text-primary-700 space-y-1 ml-5 list-disc">
          <li>Displays consensus estimates including actuals and broker averages</li>
          <li>Fiscal periods shown as dynamic columns (e.g. 1Q24, FY2025)</li>
          <li>Data sourced from InSync Consensus endpoint</li>
          <li>Requires data provider credentials to be configured in Settings</li>
        </ul>
      </div>
    </div>
  );
};

export default ConsensusTableWidgetBuilder;
